import { Button } from "@shapr3d/frontend-lib";

import { downloadPageUrl } from "../../../config";
import useNavigation from "../../../hooks/navigation";
import { useProject } from "../../../hooks/useProject";
import { useTracker } from "../../../hooks/useTracker";
import useTranslation from "../../../hooks/useTranslation";
import { Modal } from "../../../lib/modal";
import { DeepLinkIntent } from "../../../types";

import style from "./PublishVersionModal.module.css";

const PUBLISH_VERSION_VIDEO_URL =
  "https://d29vl8nlkx98pf.cloudfront.net/Shapr3D_publish_current_version_apple_2.mp4";

interface PublishVersionModalProps {
  open: boolean;
  onClose: () => void;
}

export const PublishVersionModal = ({ open, onClose }: PublishVersionModalProps) => {
  const tracker = useTracker();
  const navigation = useNavigation();
  const { t, m } = useTranslation();
  const { data: projectData, isLoading: isProjectLoading } = useProject();

  return (
    <Modal
      open={open}
      size="medium"
      isLoading={isProjectLoading}
      telemetryName="publish_version_modal"
      onClose={onClose}
    >
      <div className={style.container}>
        <div className={style.videoContainer}>
          <video
            className={style.video}
            src={PUBLISH_VERSION_VIDEO_URL}
            muted
            autoPlay
            playsInline
            loop
          />
        </div>
        <div className={style.title}>{t(m.PublishVersion.ModalTitle)}</div>
        <div className={style.description}>{t(m.PublishVersion.Description)}</div>
        <div className={style.actions}>
          <Button
            onClick={() => {
              if (projectData) {
                navigation.goToShaprApp({
                  projectId: projectData.project.projectId,
                  teamId: projectData.teamId,
                  intent: DeepLinkIntent.PublishVersion,
                  autoOpen: false,
                });
              }
            }}
          >
            {t(m.PublishVersion.LaunchShapr3D)}
          </Button>
          <a
            href={downloadPageUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              if (projectData) {
                tracker.trackDeeplinkGoToDownload({ projectId: projectData.project.projectId });
              }
            }}
          >
            <Button variant="borderless">{t(m.General.DownloadShapr3D)}</Button>
          </a>
        </div>
      </div>
    </Modal>
  );
};
